<template>
  <div class="fillcontain">
    <head-top></head-top>
    <div class="table_container">
      <el-tabs value="first" @tab-click="handleClick">
        <el-tab-pane label="网络媒体" name="first">
          <div
            class="media-cell"
            style="height: 140px; line-height: 30px; overflow: hidden"
          >
            <p style="height: 40px; width: 85px; float: left">门户类型：</p>
            <el-checkbox-group
              v-model="menhu"
              @change="onCheckbox_menhu"
              style="display: flex; flex-direction: row; flex-wrap: wrap"
            >
              <el-checkbox label="不限" @change="onCheckAll_menhu"
                >不限</el-checkbox
              >
              <el-checkbox label="新浪">新浪</el-checkbox>
              <el-checkbox label="腾讯">腾讯</el-checkbox>
              <el-checkbox label="网易">网易</el-checkbox>
              <el-checkbox label="搜狐">搜狐</el-checkbox>
              <el-checkbox label="中国网">中国网</el-checkbox>
              <el-checkbox label="中国经济网">中国经济网</el-checkbox>
              <el-checkbox label="人民网">人民网</el-checkbox>
              <el-checkbox label="新华网">新华网</el-checkbox>
              <el-checkbox label="光明网">光明网</el-checkbox>
              <el-checkbox label="中国日报网">中国日报网</el-checkbox>
              <el-checkbox label="国际在线">国际在线</el-checkbox>
              <el-checkbox label="央视网">央视网</el-checkbox>
              <el-checkbox label="和讯网">和讯网</el-checkbox>
              <el-checkbox label="中华网">中华网</el-checkbox>
              <el-checkbox label="北青网">北青网</el-checkbox>
              <el-checkbox label="环球网">环球网</el-checkbox>
              <el-checkbox label="中国青年网">中国青年网</el-checkbox>
              <el-checkbox label="中国新闻网">中国新闻网</el-checkbox>
              <el-checkbox label="南方网">南方网</el-checkbox>
              <el-checkbox label="北方网">北方网</el-checkbox>
              <el-checkbox label="慧聪网">慧聪网</el-checkbox>
              <el-checkbox label="大众网">大众网</el-checkbox>
              <el-checkbox label="央视网">央视网</el-checkbox>
              <el-checkbox label="东方网">东方网</el-checkbox>
              <el-checkbox label="央广网">央广网</el-checkbox>
              <el-checkbox label="千龙网">千龙网</el-checkbox>
              <el-checkbox label="中国经济网">中国经济网</el-checkbox>
              <el-checkbox label="海外网">海外网</el-checkbox>
              <el-checkbox label="中青在线">中青在线</el-checkbox>
              <el-checkbox label="非门户">非门户</el-checkbox>
              <el-checkbox label="其他门户">其他门户</el-checkbox>
            </el-checkbox-group>
          </div>
          <div
            class="media-cell"
            style="height: 60px; line-height: 30px; overflow: hidden"
          >
            <p style="height: 40px; width: 85px; float: left">频道类型：</p>
            <el-checkbox-group v-model="pindao" @change="onCheckbox_pindao">
              <el-checkbox label="不限" @change="onCheckAll_pindao"
                >不限</el-checkbox
              >
              <el-checkbox label="新闻资讯">新闻资讯</el-checkbox>
              <el-checkbox label="金融财经">金融财经</el-checkbox>
              <el-checkbox label="IT科技">IT科技</el-checkbox>
              <el-checkbox label="房产家居">房产家居</el-checkbox>
              <el-checkbox label="娱乐">娱乐</el-checkbox>
              <el-checkbox label="女性时尚">女性时尚</el-checkbox>
              <el-checkbox label="生活消费">生活消费</el-checkbox>
              <el-checkbox label="游戏动漫">游戏动漫</el-checkbox>
              <el-checkbox label="汽车">汽车</el-checkbox>
              <el-checkbox label="医疗健康">医疗健康</el-checkbox>
              <el-checkbox label="体育">体育</el-checkbox>
              <el-checkbox label="亲子母婴">亲子母婴</el-checkbox>
              <el-checkbox label="教育">教育</el-checkbox>
              <el-checkbox label="区块链">区块链</el-checkbox>
              <el-checkbox label="艺术文化">艺术文化</el-checkbox>
              <el-checkbox label="餐饮食品">餐饮食品</el-checkbox>
              <el-checkbox label="其他">其他</el-checkbox>
            </el-checkbox-group>
          </div>
          <div
            class="media-cell"
            style="height: 90px; line-height: 30px; overflow: hidden"
          >
            <p style="height: 80px; width: 85px; float: left">所属区域：</p>
            <el-radio v-model="quyu" label="不限">全国</el-radio>
            <el-radio v-model="quyu" label="北京">北京</el-radio>
            <el-radio v-model="quyu" label="上海">上海</el-radio>
            <el-radio v-model="quyu" label="深圳">深圳</el-radio>
            <el-radio v-model="quyu" label="广州">广州</el-radio>
            <el-radio v-model="quyu" label="杭州">杭州</el-radio>
            <el-radio v-model="quyu" label="天津">天津</el-radio>
            <el-radio v-model="quyu" label="成都">成都</el-radio>
            <el-radio v-model="quyu" label="重庆">重庆</el-radio>
            <el-radio v-model="quyu" label="长沙">长沙</el-radio>
            <el-radio v-model="quyu" label="武汉">武汉</el-radio>
            <el-radio v-model="quyu" label="苏州">苏州</el-radio>
            <el-radio v-model="quyu" label="西安">西安</el-radio>
            <el-radio v-model="quyu" label="南京">南京</el-radio>
            <el-radio v-model="quyu" label="沈阳">沈阳</el-radio>
            <el-radio v-model="quyu" label="青岛">青岛</el-radio>
            <el-radio v-model="quyu" label="四川">四川</el-radio>
            <el-radio v-model="quyu" label="河北">河北</el-radio>
            <el-radio v-model="quyu" label="贵州">贵州</el-radio>
            <el-radio v-model="quyu" label="山西">山西</el-radio>
            <el-radio v-model="quyu" label="云南">云南</el-radio>
            <el-radio v-model="quyu" label="辽宁">辽宁</el-radio>
            <el-radio v-model="quyu" label="陕西">陕西</el-radio>
            <el-radio v-model="quyu" label="吉林">吉林</el-radio>
            <el-radio v-model="quyu" label="甘肃">甘肃</el-radio>
            <el-radio v-model="quyu" label="广西">广西</el-radio>
            <el-radio v-model="quyu" label="内蒙古">内蒙古</el-radio>
            <el-radio v-model="quyu" label="新疆">新疆</el-radio>
            <el-radio v-model="quyu" label="黑龙江">黑龙江</el-radio>
            <el-radio v-model="quyu" label="青海">青海</el-radio>
            <el-radio v-model="quyu" label="西藏">西藏</el-radio>
            <el-radio v-model="quyu" label="澳门">澳门</el-radio>
            <el-radio v-model="quyu" label="香港">香港</el-radio>
            <el-radio v-model="quyu" label="海外媒体">海外媒体</el-radio>
            <el-radio v-model="quyu" label="其他">其他</el-radio>
          </div>
          <div class="media-cell">
            收录效果：
            <el-radio v-model="shoulu" label="不限">不限</el-radio>
            <el-radio v-model="shoulu" label="包网页收录">包网页收录</el-radio>
            <el-radio v-model="shoulu" label="网页收录">网页收录</el-radio>
            <el-radio v-model="shoulu" label="百度新闻源收录"
              >百度新闻源收录</el-radio
            >
            <el-radio v-model="shoulu" label="包百度新闻收录"
              >包百度新闻收录</el-radio
            >
          </div>
          <div class="media-cell">
            <p style="height: 40px; width: 85px; float: left">投放类型：</p>
            <el-checkbox-group v-model="toufang" @change="onCheckbox_toufang">
              <el-checkbox label="不限" @change="onCheckAll_toufang"
                >不限</el-checkbox
              >
              <el-checkbox label="转载">转载</el-checkbox>
              <el-checkbox label="首发">首发</el-checkbox>
              <el-checkbox label="焦点图">焦点图</el-checkbox>
              <el-checkbox label="文字链">文字链</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="media-cell">
            价格区间：
            <el-radio v-model="jiage" label="0">不限</el-radio>
            <el-radio v-model="jiage" label="1">0-20</el-radio>
            <el-radio v-model="jiage" label="2">21-50</el-radio>
            <el-radio v-model="jiage" label="3">51-75</el-radio>
            <el-radio v-model="jiage" label="4">76-100</el-radio>
            <el-radio v-model="jiage" label="5">100以上</el-radio>
          </div>
          <div class="media-cell">
            <p style="height: 40px; width: 85px; float: left">其他选项：</p>
            <el-checkbox-group v-model="other" @change="onCheckbox_other">
              <el-checkbox label="不限" @change="onCheckAll_other"
                >不限</el-checkbox
              >
              <el-checkbox label="周末可发">周末可发</el-checkbox>
              <el-checkbox label="秒发">秒发</el-checkbox>
              <el-checkbox label="节假日可发">节假日可发</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="media-cell" style="height: 60px; line-height: 50px">
            媒体名称：
            <div class="media-input">
              <el-input
                v-model="sousuo"
                @keyup.enter.native="search(1)"
                placeholder="请输入媒体编号或名称"
              ></el-input>
            </div>
            <p class="media-p1">可发内链</p>
            <div class="media-select">
              <el-select v-model="value" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <p class="media-p2">可发联系方式</p>
            <div class="media-select2">
              <el-select v-model="value2" placeholder="请选择">
                <el-option
                  v-for="item in options2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="media-p3">
              <el-button type="primary" @click="search(1)">搜索</el-button>
              <el-button type="button" @click="resh">重置</el-button>
            </div>
          </div>
          <el-table
            :data="tableData"
            highlight-current-row
            style="width: 100%"
            v-loading="loading"
          >
            <el-table-column label="媒体名称" width="95%">
              <template slot-scope="scope">
                <a
                  style="color: #000000"
                  target="_blank"
                  rel="noopener noreferrer"
                  :href="scope.row.mediaCase"
                  >{{ scope.row.name }}</a
                >
              </template>
            </el-table-column>
            <el-table-column property="price" label="价格" width="80%">
              <template slot-scope="scope">
                <a>{{ scope.row.price + scope.row.addPrice }}</a>
              </template>
            </el-table-column>
            <el-table-column
              property="channel"
              label="频道类型"
              width="80%"
            ></el-table-column>
            <el-table-column
              property="area"
              label="地区"
              width="80%"
            ></el-table-column>
            <el-table-column
              property="linkable"
              label="是否带链接"
              width="90%"
            ></el-table-column>
            <el-table-column
              property="contactable"
              label="带联系方式"
              width="90%"
            ></el-table-column>
            <el-table-column
              property="rate"
              label="出稿率"
              width="80%"
            ></el-table-column>
            <el-table-column
              property="speed"
              label="出稿速度"
              width="80%"
            ></el-table-column>
            <el-table-column
              property="included"
              label="收录类型"
              width="80%"
            ></el-table-column>
            <el-table-column property="auth" label="是否认证" width="80%">
              <template slot-scope="scope">
                <a v-if="scope.row.auth == '已认证'" class="yrz">
                  {{ scope.row.auth }}
                </a>
                <a v-else class="wrz">{{ scope.row.auth }}</a>
              </template>
            </el-table-column>
            <el-table-column property="remark" label="备注">
              <template slot-scope="scope">
                <el-popover
                  placement="top-start"
                  width="360"
                  trigger="hover"
                  :content="scope.row.remark"
                >
                  <p class="over_text" slot="reference">
                    {{ scope.row.remark }}
                  </p>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
          <div class="Pagination" style="text-align: left; margin-top: 10px">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="index"
              :page-size="20"
              layout="total, prev, pager, next"
              :total="count"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="自媒体" name="second">
          <div
            class="media-cell"
            style="height: 60px; line-height: 30px; overflow: hidden"
          >
            <p style="height: 40px; width: 85px; float: left">所属平台：</p>
            <el-checkbox-group v-model="menhu2" @change="onCheckbox_menhu2">
              <el-checkbox label="不限" @change="onCheckAll_menhu2"
                >不限</el-checkbox
              >
              <el-checkbox label="新浪微博">新浪微博</el-checkbox>
              <el-checkbox label="微信微信公众号">微信微信公众号</el-checkbox>
              <el-checkbox label="今日头条">今日头条</el-checkbox>
              <el-checkbox label="百度百家">百度百家</el-checkbox>
              <el-checkbox label="网易号">网易号</el-checkbox>
              <el-checkbox label="腾讯号">腾讯号</el-checkbox>
              <el-checkbox label="新浪头条">新浪头条</el-checkbox>
              <el-checkbox label="搜狐头条">搜狐头条</el-checkbox>
              <el-checkbox label="雪球号">雪球号</el-checkbox>
              <el-checkbox label="一点资讯">一点资讯</el-checkbox>
              <el-checkbox label="UC头条">UC头条</el-checkbox>
              <el-checkbox label="凤凰号">凤凰号</el-checkbox>
              <el-checkbox label="知乎号">知乎号</el-checkbox>
              <el-checkbox label="其他">其他</el-checkbox>
            </el-checkbox-group>
          </div>
          <div
            class="media-cell"
            style="height: 60px; line-height: 30px; overflow: hidden"
          >
            <p style="height: 40px; width: 85px; float: left">行业类型：</p>
            <el-checkbox-group v-model="pindao2" @change="onCheckbox_pindao2">
              <el-checkbox label="不限" @change="onCheckAll_pindao2"
                >不限</el-checkbox
              >
              <el-checkbox label="新闻资讯">新闻资讯</el-checkbox>
              <el-checkbox label="财经金融">财经金融</el-checkbox>
              <el-checkbox label="3C科技">3C科技</el-checkbox>
              <el-checkbox label="家居房产">家居房产</el-checkbox>
              <el-checkbox label="时尚女性">时尚女性</el-checkbox>
              <el-checkbox label="母婴健康">母婴健康</el-checkbox>
              <el-checkbox label="汽车娱乐">汽车娱乐</el-checkbox>
              <el-checkbox label="教育体育">教育体育</el-checkbox>
              <el-checkbox label="文化旅游">文化旅游</el-checkbox>
              <el-checkbox label="生活美食">生活美食</el-checkbox>
              <el-checkbox label="游戏动漫">游戏动漫</el-checkbox>
              <el-checkbox label="其他">其他</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="media-cell">
            参考粉丝量：
            <el-radio v-model="quyu2" label="不限">不限</el-radio>
            <el-radio v-model="quyu2" label="0-5000">0-5000</el-radio>
            <el-radio v-model="quyu2" label="5001-1万">5001-1万</el-radio>
            <el-radio v-model="quyu2" label="1万-5万">1万-5万</el-radio>
            <el-radio v-model="quyu2" label="5万-10万">5万-10万</el-radio>
            <el-radio v-model="quyu2" label="10万以上">10万以上</el-radio>
          </div>
          <div class="media-cell">
            参考阅读量：
            <el-radio v-model="shoulu2" label="不限">不限</el-radio>
            <el-radio v-model="shoulu2" label="1000以下">1000以下</el-radio>
            <el-radio v-model="shoulu2" label="1000-5000">1000-5000</el-radio>
            <el-radio v-model="shoulu2" label="5000-1万">5000-1万</el-radio>
          </div>
          <div class="media-cell">
            <p style="height: 40px; width: 85px; float: left">投放类型：</p>
            <el-checkbox-group v-model="toufang2" @change="onCheckbox_toufang2">
              <el-checkbox label="不限" @change="onCheckAll_toufang2"
                >不限</el-checkbox
              >
              <el-checkbox label="转载">转载</el-checkbox>
              <el-checkbox label="首发">首发</el-checkbox>
              <el-checkbox label="焦点图">焦点图</el-checkbox>
              <el-checkbox label="文字链">文字链</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="media-cell">
            价格区间：
            <el-radio v-model="jiage2" label="0">不限</el-radio>
            <el-radio v-model="jiage2" label="1">0-1000</el-radio>
            <el-radio v-model="jiage2" label="2">1001-5000</el-radio>
            <el-radio v-model="jiage2" label="3">5001-1万</el-radio>
            <el-radio v-model="jiage2" label="4">1万-3万</el-radio>
            <el-radio v-model="jiage2" label="5">3万以上</el-radio>
          </div>
          <div class="media-cell">
            <p style="height: 40px; width: 85px; float: left">其他选项：</p>
            <el-checkbox-group v-model="other2" @change="onCheckbox_other2">
              <el-checkbox label="不限" @change="onCheckAll_other2"
                >不限</el-checkbox
              >
              <el-checkbox label="周末可发">周末可发</el-checkbox>
              <el-checkbox label="秒发">秒发</el-checkbox>
              <el-checkbox label="节假日可发">节假日可发</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="media-cell" style="height: 60px; line-height: 50px">
            媒体名称：
            <div class="media-input">
              <el-input
                v-model="sousuo2"
                @keyup.enter.native="search2(1)"
                placeholder="请输入媒体编号或名称"
              ></el-input>
            </div>
            <p class="media-p1">可发内链</p>
            <div class="media-select">
              <el-select v-model="value_2" placeholder="请选择">
                <el-option
                  v-for="item in options_2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <p class="media-p2">可发联系方式</p>
            <div class="media-select2">
              <el-select v-model="value2_2" placeholder="请选择">
                <el-option
                  v-for="item in options2_2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="media-p3">
              <el-button type="primary" @click="search2(1)">搜索</el-button>
            </div>
          </div>
          <!-- mediaCase -->
          <el-table
            :data="tableData2"
            highlight-current-row
            style="width: 100%"
            v-loading="loading"
          >
            <el-table-column label="媒体名称" width="95%">
              <template slot-scope="scope">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  :href="scope.row.mediaCase"
                  >{{ scope.row.name }}</a
                >
              </template>
            </el-table-column>
            <el-table-column property="price" label="价格" width="50%">
              <template slot-scope="scope">
                <a>{{ scope.row.price + scope.row.addPrice }}</a>
              </template>
            </el-table-column>
            <el-table-column
              property="portal"
              label="平台"
              width="80%"
            ></el-table-column>
            <el-table-column
              property="channel"
              label="行业"
              width="80%"
            ></el-table-column>
            <el-table-column
              property="linkable"
              label="是否带链接"
              width="90%"
            ></el-table-column>
            <el-table-column
              property="contactable"
              label="带联系方式"
              width="90%"
            ></el-table-column>
            <el-table-column
              property="rate"
              label="出稿率"
              width="80%"
            ></el-table-column>
            <el-table-column
              property="speed"
              label="出稿速度"
              width="80%"
            ></el-table-column>
            <el-table-column
              property="area"
              label="粉丝数"
              width="80%"
            ></el-table-column>
            <el-table-column
              property="included"
              label="参考阅读量"
              width="80%"
            ></el-table-column>
            <el-table-column property="auth" label="是否认证" width="80%">
              <template slot-scope="scope">
                <a v-if="scope.row.auth == '已认证'" class="yrz">
                  {{ scope.row.auth }}
                </a>
                <a v-else class="wrz">{{ scope.row.auth }}</a>
              </template>
            </el-table-column>
            <el-table-column property="remark" label="备注">
              <template slot-scope="scope">
                <el-popover
                  placement="top-start"
                  width="360"
                  trigger="hover"
                  :content="scope.row.remark"
                >
                  <p class="over_text" slot="reference">
                    {{ scope.row.remark }}
                  </p>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
          <div class="Pagination" style="text-align: left; margin-top: 10px">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange2"
              :current-page="index2"
              :page-size="20"
              layout="total, prev, pager, next"
              :total="count2"
            ></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import myAxios from "../myAxios";
import HeadTop from "../components/HeadTop";

export default {
  data() {
    return {
      tab_index: 0,
      mediaType: 1,
      saveCount: "",
      mediaIds: [],
      mediaIds2: [],
      total: 0, //总价
      total2: 0, //总价
      url: localStorage.getItem("url"),
      tableData: [], //用户列表数据
      tableData2: [], //用户列表数据
      index: 1, //页码
      index2: 1, //页码
      size: 20, //页大小
      count: 0, //数据总数
      count2: 0, //数据总数
      loading: false, //加载状态
      menhu: ["不限"],
      pindao: ["不限"],
      quyu: "不限",
      shoulu: "不限",
      toufang: ["不限"],
      toufang2: ["不限"],
      jiage: "0",
      menhu2: ["不限"],
      pindao2: ["不限"],
      quyu2: "不限",
      shoulu2: "不限",
      jiage2: "0",
      other: ["不限"],
      other2: ["不限"],
      sousuo: "", //媒体名称
      sousuo2: "", //媒体名称
      options: [
        //可发内链
        {
          //选择器1
          value: "请选择",
          label: "",
        },
        {
          value: "是",
          label: "是",
        },
        {
          value: "否",
          label: "否",
        },
      ],
      value: "", //选择器1
      options2: [
        //可发联系方式
        {
          //选择器2
          value: "请选择",
          label: "",
        },
        {
          value: "是",
          label: "是",
        },
        {
          value: "否",
          label: "否",
        },
      ],
      value2: "", //选择器2
      options_2: [
        //可发内链
        {
          //选择器1
          value: "请选择",
          label: "",
        },
        {
          value: "是",
          label: "是",
        },
        {
          value: "否",
          label: "否",
        },
      ],
      value_2: "", //选择器1
      options2_2: [
        //可发联系方式
        {
          //选择器2
          value: "请选择",
          label: "",
        },
        {
          value: "是",
          label: "是",
        },
        {
          value: "否",
          label: "否",
        },
      ],
      value2_2: "", //选择器2
    };
  },
  components: {
    HeadTop,
  },
  created() {
    this.initData();
  },
  methods: {
    // 搜索
    search(num) {
      if (num) {
        this.index = 1;
      }
      var data = {
        username: localStorage.getItem("username"),
        selfMedia: false,
        portals: this.menhu,
        channels: this.pindao,
        area: this.quyu,
        included: this.shoulu,
        priceRange: this.jiage,
        name: this.sousuo.replace(/\s*/g, ""),
        linkable: this.value,
        contactable: this.value2,
        others: this.other,
        lanuch: this.toufang.join("-"),
        index: this.index,
        size: this.size,
      };
      myAxios.post(`/client_user/Medias/v1`, data).then((res) => {
        this.tableData = res.data;
        for (var i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].auth) {
            this.tableData[i].auth = "已认证";
          } else {
            this.tableData[i].auth = "未认证";
          }
          if (this.tableData[i].contactable) {
            this.tableData[i].contactable = "是";
          } else {
            this.tableData[i].contactable = "否";
          }
          if (this.tableData[i].linkable) {
            this.tableData[i].linkable = "是";
          } else {
            this.tableData[i].linkable = "否";
          }
        }

        this.count = res.total;
      });
    },
    search2(num) {
      if (num) {
        this.index2 = 0;
      }
      var data = {
        username: localStorage.getItem("username"),
        selfMedia: true,
        portals: this.menhu2,
        channels: this.pindao2,
        area: this.quyu2,
        included: this.shoulu2,
        priceRange: this.jiage2,
        name: this.sousuo2.replace(/\s*/g, ""),
        linkable: this.value_2,
        contactable: this.value2_2,
        others: this.other2,
        lanuch: this.toufang2.join("-"),
        index: this.index2,
        size: this.size,
      };
      myAxios.post(`/client_user/Medias/v1`, data).then((res) => {
        this.tableData2 = res.data;
        for (var i = 0; i < this.tableData2.length; i++) {
          if (this.tableData2[i].auth) {
            this.tableData2[i].auth = "已认证";
          } else {
            this.tableData2[i].auth = "未认证";
          }
          if (this.tableData2[i].contactable) {
            this.tableData2[i].contactable = "是";
          } else {
            this.tableData2[i].contactable = "否";
          }
          if (this.tableData2[i].linkable) {
            this.tableData2[i].linkable = "是";
          } else {
            this.tableData2[i].linkable = "否";
          }
        }
        this.count2 = res.total;
      });
    },
    async initData() {
      try {
        this.getUsers();
      } catch (err) {
        console.log("获取数据失败");
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },

    handleCurrentChange(val) {
      console.log(val);
      this.index = val;
      this.search();
    },
    handleCurrentChange2(val) {
      console.log(val);
      this.index2 = val;
      this.search2();
    },
    handleSelectionChange(val) {
      console.log(val);
      this.total = 0;
      this.mediaIds = [];
      if (val.length > 0) {
        for (var i = 0; i < val.length; i++) {
          this.total = this.total + val[i].price;
          this.mediaIds.push(val[i].id);
        }
      }
    },
    handleSelectionChange2(val) {
      console.log(val);
      this.total2 = 0;
      this.mediaIds2 = [];
      if (val.length > 0) {
        for (var i = 0; i < val.length; i++) {
          this.total2 = this.total2 + val[i].price;
          this.mediaIds2.push(val[i].id);
        }
      }
    },
    // 重置
    resh() {
      this.$router.go(0);
    },
    async getUsers() {
      if (this.mediaType == 1) {
        var data = {
          username: localStorage.getItem("username"),
          mediaType: 1,
          index: this.index,
          size: this.size,
        };
        myAxios.post(`/client_user/Medias/v1`, data).then((res) => {
          this.tableData = res.data;
          for (var i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].auth) {
              this.tableData[i].auth = "已认证";
            } else {
              this.tableData[i].auth = "未认证";
            }
            if (this.tableData[i].contactable) {
              this.tableData[i].contactable = "是";
            } else {
              this.tableData[i].contactable = "否";
            }
            if (this.tableData[i].linkable) {
              this.tableData[i].linkable = "是";
            } else {
              this.tableData[i].linkable = "否";
            }
          }

          this.count = res.total;
        });
      } else if (this.mediaType == 2) {
        var data2 = {
          username: localStorage.getItem("username"),
          mediaType: 2,
          index: this.index2,
          size: this.size,
        };
        myAxios.post(`/client_user/Medias/v1`, data2).then((res) => {
          this.tableData2 = res.data;
          for (var i = 0; i < this.tableData2.length; i++) {
            if (this.tableData2[i].auth) {
              this.tableData2[i].auth = "已认证";
            } else {
              this.tableData2[i].auth = "未认证";
            }
            if (this.tableData2[i].contactable) {
              this.tableData2[i].contactable = "是";
            } else {
              this.tableData2[i].contactable = "否";
            }
            if (this.tableData2[i].linkable) {
              this.tableData2[i].linkable = "是";
            } else {
              this.tableData2[i].linkable = "否";
            }
          }
          this.count2 = res.total;
        });
      }
      this.loading = false;
    },
    handleClick(tab, event) {
      console.log(tab.index);
      this.mediaType = Number(tab.index) + 1;
      this.tab_index = tab.index;
      if(this.mediaType==1||this.mediaType==2){
        this.getUsers()
      }
    },
    onCheckbox_menhu(val) {
      if (val[0] == "不限" && val.length > 1) {
        this.menhu.shift();
        console.log(this.menhu);
      }
    },
    onCheckbox_pindao(val) {
      if (val[0] == "不限" && val.length > 1) {
        this.pindao.shift();
        console.log(this.pindao);
      }
    },
    onCheckbox_toufang(val) {
      if (val[0] == "不限" && val.length > 1) {
        this.toufang.shift();
        console.log(this.toufang);
      }
    },
    onCheckAll_toufang(val) {
      // console.log(val)
      if (val) {
        this.toufang = ["不限"];
      }
    },
    onCheckbox_toufang2(val) {
      if (val[0] == "不限" && val.length > 1) {
        this.toufang2.shift();
        console.log(this.toufang2);
      }
    },
    onCheckAll_toufang2(val) {
      // console.log(val)
      if (val) {
        this.toufang2 = ["不限"];
      }
    },
    onCheckbox_other(val) {
      if (val[0] == "不限" && val.length > 1) {
        this.other.shift();
      }
    },
    onCheckAll_menhu(val) {
      // console.log(val)
      if (val) {
        this.menhu = ["不限"];
      }
    },
    onCheckAll_pindao(val) {
      // console.log(val)
      if (val) {
        this.pindao = ["不限"];
      }
    },
    onCheckAll_other(val) {
      // console.log(val)
      if (val) {
        this.other = ["不限"];
      }
    },
    onCheckbox_menhu2(val) {
      if (val[0] == "不限" && val.length > 1) {
        this.menhu2.shift();
        console.log(this.menhu2);
      }
    },
    onCheckbox_pindao2(val) {
      if (val[0] == "不限" && val.length > 1) {
        this.pindao2.shift();
        console.log(this.pindao2);
      }
    },
    onCheckbox_other2(val) {
      if (val[0] == "不限" && val.length > 1) {
        this.other2.shift();
      }
    },
    onCheckAll_menhu2(val) {
      // console.log(val)
      if (val) {
        this.menhu2 = ["不限"];
      }
    },
    onCheckAll_pindao2(val) {
      // console.log(val)
      if (val) {
        this.pindao2 = ["不限"];
      }
    },
    onCheckAll_other2(val) {
      // console.log(val)
      if (val) {
        this.other2 = ["不限"];
      }
    },
  },
};
</script>

<style lang="less">
@import "../style/mixin";
.btn_bottom {
  position: fixed;
  bottom: 5px;
  right: 50px;
}
.table_container {
  padding: 20px;
}
.media-cell {
  position: relative;
  height: 30px;
  border-bottom-color: #eeeeee;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  margin-top: 10px;
}
.media-input {
  width: 200px;
  height: 10px;
  position: absolute;
  top: 0;
  left: 8%;
}
.media-p1 {
  position: absolute;
  top: 0;
  left: 28%;
}
.media-select {
  position: absolute;
  top: 0;
  left: 35%;
}
.media-p2 {
  position: absolute;
  top: 0;
  left: 55%;
}
.media-p3 {
  position: absolute;
  top: 0;
  left: 85%;
}
.media-select2 {
  position: absolute;
  top: 0;
  left: 65%;
}
.choose-bottom {
  position: fixed;
  bottom: 0;
  left: 16%;
  padding-left: 2%;
  background-color: aliceblue;
  height: 50px;
  line-height: 50px;
  width: 100%;
  font-weight: bold;
  font-size: 10pt;
}
.yrz {
  color: #fd5353;
  border: 1px solid #fd5353;
  border-radius: 5px;
  font-size: 9pt;
  padding: 1px;
}
.wrz {
  background-color: #bdbdbd;
  color: #ffffff;
  border-radius: 5px;
  font-size: 9pt;
  padding: 1px;
}
.over_text {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>